module.exports = __webpack_public_path__ + "static/img/block-4.39645ae5.png";